module.exports = __webpack_public_path__ + "cf137d2d13d78a13afba8046ca1117ea.svg";